export const HttpConsts = {
  SuccessCode: "200",
  ErrorCode: "500",
  Unauthorized: "401",
};
